import { CommissionListView } from '../components/commissions/CommissionListView';

export function CommissionsPage() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-gray-900">Commissions</h1>
      <CommissionListView />
    </div>
  );
}
